import { render, staticRenderFns } from "./file-uploader.vue?vue&type=template&id=479bc80d&scoped=true"
import script from "./file-uploader.vue?vue&type=script&lang=js"
export * from "./file-uploader.vue?vue&type=script&lang=js"
import style0 from "./file-uploader.vue?vue&type=style&index=0&id=479bc80d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479bc80d",
  null
  
)

export default component.exports